import React from "react";
import { Stack, Typography } from "@mui/material";

import { FOUNDRIES } from "../../constants";
import { HubMaterialHookSelect } from "../../components";

import ItemsTableRow from "./ItemsTableRow";
import { StyledItemRow } from "./styles";

const grindGates = [
  { id: 1, label: "Flush" },
  { id: 2, label: "Witness" },
];

const handBlastingOptions = [
  {
    id: 0,
    label: "0 - Not Required",
  },
  {
    id: 1,
    label: "1 - Yes But Easy",
  },
  {
    id: 2,
    label: "2 - Medium",
  },
  {
    id: 3,
    label: "3 - Holes",
  },
];

const moldTypes = ["Manual", "Automatic"]?.map((label, id) => ({
  id,
  label,
}));

const checkboxes = [
  {
    id: "handDipping",
    label: "Hand Dipping",
  },
  {
    id: "flashing",
    label: "Flashing",
  },
  {
    id: "hardToFixture",
    label: "Hard to Fixture",
  },
  {
    id: "weldRepair",
    label: "Weld Repair",
  },
  {
    id: "fineDetail",
    label: "Fine Detail",
  },
  {
    id: "straightening",
    label: "Straightening",
  },
];

const ItemFields = () => {
  return (
    <>
      <StyledItemRow>
        <ItemsTableRow
          name="estimatedScrapRate"
          label="Anticipated Rejection Rate"
          endAdornment="%"
        />
      </StyledItemRow>
      <StyledItemRow>
        <ItemsTableRow
          fieldType="select"
          name="moldType"
          label="Mold Type"
          options={moldTypes}
          defaultValue={true}
        />
      </StyledItemRow>

      <StyledItemRow>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="caption" className="ItemCell-root">
            Tree Type
          </Typography>
        </Stack>
        <HubMaterialHookSelect
          name="treeId"
          type="trees"
          hideLabel
          required={false}
          allowNull={false}
        />
      </StyledItemRow>
      <StyledItemRow>
        <ItemsTableRow name="partsPerTree" label="Parts / Tree" isNumber />
      </StyledItemRow>
      <StyledItemRow>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="caption" className="ItemCell-root">
            Metal Alloy
          </Typography>
        </Stack>
        <HubMaterialHookSelect
          name="materialId"
          hideLabel
          required={false}
          allowNull={false}
          showOnlyGroup="Metal"
        />
      </StyledItemRow>
      <StyledItemRow>
        <ItemsTableRow
          fieldType="select"
          name="handBlasting"
          label="Hand Blasting"
          options={handBlastingOptions}
          useDefault
        />
      </StyledItemRow>
      <StyledItemRow>
        <ItemsTableRow
          fieldType="select"
          name="flushWitness"
          label="Grind Gate"
          options={grindGates}
        />
      </StyledItemRow>
      <StyledItemRow>
        <ItemsTableRow
          name="gates"
          label="Gates"
          placeholder="ex. 4"
          defaultValue={1}
          isNumber
        />
      </StyledItemRow>
      {checkboxes.map((c) => (
        <StyledItemRow>
          <ItemsTableRow
            fieldType="checkbox"
            name={c.id}
            key={c.id}
            label={c.label}
            labelPlacement="end"
            isCheckbox
          />
        </StyledItemRow>
      ))}
    </>
  );
};

export default ItemFields;
